import {AccountActions, AccountActionType} from './account.types';
import {AccountState} from "../../util/interfaces";


const initialState: AccountState = {
  accountInfo: null,
  isShopifyAdded: false,
  accountError: '',
  isSetupComplete: false,
  shopifyShop: '',
  shops: null
};

export const accountReducer = (state: AccountState = initialState, action: AccountActionType): AccountState => {
  switch(action.type){

    case AccountActions.SUCCESS_GET_ACCOUNT:
      // determine if setup is complete
      const email = action.payload.verified;
      const verification = action.payload.appliedTier || action.payload.appliedTier > -1;
      const settlementInfo = action.payload.settlementInfos.length;
      const isSetupComplete = !!(email && verification && settlementInfo);

      //check for shopify shops
      const shops = action.payload.integrations?.shopify?.shopInfo.reduce((reducer: string[], curShop) => {
        reducer.push(curShop.name);
        return reducer;
      }, []) || null;

      return {...state, accountInfo: action.payload, isSetupComplete, accountError: '', shops};
    case AccountActions.FAILED_GET_ACCOUNT:
      return {...state, accountError: action.payload}
    case AccountActions.SUCCESS_ADD_SHOPIFY_ATTRIBUTES:
      return {...state, isShopifyAdded: true, shopifyShop: action.payload, accountError: ''}
    case AccountActions.FAILED_ADD_SHOPIFY_ATTRIBUTES:
      return {...state, isShopifyAdded: true, accountError: action.payload}
    case AccountActions.CLEAR_ACCOUNT_ERROR:
      return {...state, accountError: ''}
    default:
      return state
  }
}
